import React from 'react';
import { Container } from 'react-bootstrap';
import NavBar from './NavBar';

export default function PacienteLayout({ children }) {
  return (
    <Container fluid>
      <NavBar />
      {children}
    </Container>
  );
}
